import { connect } from "react-redux";
import { withRouter } from "react-router";
import { toggleRightDrawer } from "header/ducks";
import HeaderButtons from "your_projects/components/header_buttons";

export default withRouter(connect(null, { toggleRightDrawer })(HeaderButtons));
